import script from "./NotificationInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationInfoModal.vue?vue&type=style&index=0&id=37c59e7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c59e7b"]])

export default __exports__